module.exports = __webpack_public_path__ + "img/mais-info.88470f09.svg";